<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="full-height">
    <div class="border-bottom border-gray d-flex align-items-center justify-content-center mt-3 pb-3 mb-0 h5" i18n>
        <i class="ni ni-badge mr-3 "></i>
        Groups
    </div>

    <div class="px-5 py-4 border-bottom border-gray bg-lighter">
        <div class="content-wrapper">
            <button class="btn btn-link text-info d-flex align-items-center justify-content-center p-0 mb-2 font-weight-normal"
                [routerLink]="'../'" i18n>
                <i class="ni ni-bold-left mr-1"></i> Back
            </button>
            <div class="d-flex justify-content-between">
                <h2 class="display-2" i18n>Add New Group</h2>
            </div>
        </div>
    </div>
    <div class="p-5 mb-4 border-bottom flex-1">
        <div class="content-wrapper">
            <h3 class="mb-4 font-weight-bold" i18n>Enter Group Details</h3>
            <form [formGroup]="groupForm">

                <app-input-text label="Group Name" formControlName="groupName" [errorMessages]="nameControlErrors">
                </app-input-text>

                <app-input-text label="Group Description" type="textarea" formControlName="groupDescription"
                    [errorMessages]="descriptionControlErrors">
                </app-input-text>

                <app-selectable-field *ngIf="_isUserAllowed; else otherRolesTemplate" formControlName="account"
                    label="Organization Name">
                </app-selectable-field>

                <ng-template #otherRolesTemplate>
                    <app-input-text label="Organization" formControlName="account">
                    </app-input-text>
                </ng-template>

            </form>
        </div>
    </div>

    <div class="d-flex mb-3 px-5">
        <div class="content-wrapper d-flex justify-content-between width-100">
            <button class="btn btn-size-normal btn-outline-default" (click)="cancel()">
                <span class="btn-inner--text" i18n>Cancel</span>
            </button>
            <button class="btn btn-size-normal btn-info" (click)="submit()" [disabled]="!isFormValid()">
                <span class="btn-inner--text" i18n>Add Group</span>
            </button>

        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/access-management/groups/group-create/group-create.component.html